import type { Character } from "@/mocks/characters";

const colorMap: Record<string, { chip: string; icon: string; tag: string }> = {
  primary: {
    chip: "bg-primary-500 text-background-50",
    icon: "bg-primary-100 text-primary-700",
    tag: "bg-primary-50 text-primary-700 border border-primary-200",
  },
  accent: {
    chip: "bg-accent-500 text-background-50",
    icon: "bg-accent-100 text-accent-700",
    tag: "bg-accent-50 text-accent-700 border border-accent-200",
  },
  secondary: {
    chip: "bg-secondary-500 text-background-50",
    icon: "bg-secondary-100 text-secondary-700",
    tag: "bg-secondary-50 text-secondary-700 border border-secondary-200",
  },
};

export default function CharacterCard({ character }: { character: Character }) {
  const c = colorMap[character.color] ?? colorMap.primary;
  return (
    <article className="group overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-transform duration-300 hover:-translate-y-1">
      <div className="relative aspect-[4/5] overflow-hidden">
        <img
          src={character.image}
          alt={`继母与继姐漫画角色${character.role}${character.name}人物设定`}
          title={`${character.name} ${character.role}设定`}
          className="h-full w-full object-top object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span className={`absolute left-3 top-3 rounded-md px-3 py-1 text-xs font-medium ${c.chip}`}>
          {character.role}
        </span>
      </div>
      <div className="p-4 md:p-5">
        <div className="flex items-center justify-between">
          <h3 className="font-heading text-lg font-bold text-foreground-950">{character.name}</h3>
          <span className="grid h-8 w-8 items-center justify-center rounded-full text-sm">
            <i className={`ri-user-heart-line ${c.icon}`}></i>
          </span>
        </div>
        <p className="mt-1 text-xs font-medium text-primary-700">{character.tagline}</p>
        <p className="mt-3 text-sm leading-6 text-foreground-700">{character.summary}</p>
        <div className="mt-4 flex flex-wrap gap-2">
          {character.keyFacts.map((f) => (
            <span key={f} className={`rounded-md px-2.5 py-1 text-xs ${c.tag}`}>
              {f}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
}